import usePageId from '@hooks/usePageId';
import { Navigate } from 'react-router';

export default function Home() {
	usePageId('home');

	if (__SERVER__) {
		return null;
	}
	return <Navigate to="/sentinel" replace />;
}
